import { Component, input } from '@angular/core';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';
import { RdsDividerModule, RdsIconsModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-offering-features-list',
  imports: [DynamicModule, RdsIconsModule, RdsDividerModule],
  templateUrl: './offering-features.component.html',
  styleUrl: './offering-features.component.scss',
})
export class OfferingFeaturesComponent {
  components = Components;

  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  features = input<any[]>();

}
